/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { Crafting, CraftingInterface } from "../Crafting";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "rand_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
    ],
    name: "Craft_BuildingNotExists",
    type: "error",
  },
  {
    inputs: [],
    name: "Craft_InvalidArrayLength",
    type: "error",
  },
  {
    inputs: [],
    name: "Craft_InvalidClaimParams",
    type: "error",
  },
  {
    inputs: [],
    name: "Craft_InvalidConsumeTokenAmount",
    type: "error",
  },
  {
    inputs: [],
    name: "Craft_InvalidMaxQueueParam",
    type: "error",
  },
  {
    inputs: [],
    name: "Craft_InvalidMetadataLimits",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxAmount",
        type: "uint256",
      },
    ],
    name: "Craft_InvalidMinMaxTokenAmounts",
    type: "error",
  },
  {
    inputs: [],
    name: "Craft_InvalidRentFee",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "landBuildingHash",
        type: "bytes32",
      },
    ],
    name: "Craft_LandBuildingDoesNotExist",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenId",
        type: "uint256",
      },
    ],
    name: "Craft_LandNotOwned",
    type: "error",
  },
  {
    inputs: [],
    name: "Craft_NothingToClaim",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
    ],
    name: "Craft_ProducesTokenIsNFT",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
    ],
    name: "Craft_ProducesTokenIsNotNFT",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
    ],
    name: "Craft_RecipeDoesNotSupportTimeBasedCrafting",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
    ],
    name: "Craft_RecipeExpired",
    type: "error",
  },
  {
    inputs: [],
    name: "Craft_RecipeIdAndMaxQueueArraysLengthMismatch",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "landBuildingHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
    ],
    name: "Craft_RecipeIsFull",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
    ],
    name: "Craft_RecipeNotAddedToBuilding",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
    ],
    name: "Craft_RecipeNotExists",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
    ],
    name: "Craft_TokenIsNotListed",
    type: "error",
  },
  {
    inputs: [],
    name: "Ownable_NewOwnerCannotBeAddressZero",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "Ownable_SenderIsNotOwner",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "tokenName",
        type: "string",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "newValue",
        type: "bool",
      },
    ],
    name: "ConsumesTokenToggled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "designerAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "newValue",
        type: "bool",
      },
    ],
    name: "DesignerToggled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "tokenName",
        type: "string",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "newValue",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isNFT",
        type: "bool",
      },
    ],
    name: "ProducesTokenToggled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
    ],
    name: "RecipeAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "maxQueue",
        type: "uint256",
      },
    ],
    name: "RecipeAddedToBuilding",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "multiplier",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "landBuildingHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "RecipeAddedToQueue",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "multiplier",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "landBuildingHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "RecipeClaimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "multiplier",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "landBuildingHash",
        type: "bytes32",
      },
    ],
    name: "RecipeCrafted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
    ],
    name: "RecipeRemovedFromBuilding",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
    ],
    name: "RecipeUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "landBuildingHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "newValue",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "rentFee",
        type: "uint256",
      },
    ],
    name: "RentConfigUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newTreasury",
        type: "address",
      },
    ],
    name: "TreasuryChanged",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "landBuildingHash",
        type: "bytes32",
      },
    ],
    name: "activeRecipes",
    outputs: [
      {
        internalType: "bool",
        name: "result",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "producesToken",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isNFT",
        type: "bool",
      },
    ],
    name: "addProduceToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "enum ICraft.Action",
            name: "action",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "tokenAmount",
            type: "uint256",
          },
        ],
        internalType: "struct ICraft.Consumes[]",
        name: "consumes",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "bool",
            name: "isNFT",
            type: "bool",
          },
          {
            internalType: "uint128",
            name: "minTokenAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "maxTokenAmount",
            type: "uint128",
          },
          {
            internalType: "uint16[]",
            name: "metadataLimits",
            type: "uint16[]",
          },
        ],
        internalType: "struct ICraft.Produces[]",
        name: "produces",
        type: "tuple[]",
      },
      {
        internalType: "uint40",
        name: "duration",
        type: "uint40",
      },
      {
        internalType: "enum ICraft.RecipeQueueType",
        name: "queueType",
        type: "uint8",
      },
    ],
    name: "addRecipe",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
      {
        internalType: "uint256[]",
        name: "recipeIds",
        type: "uint256[]",
      },
      {
        internalType: "uint32[]",
        name: "maxQueues",
        type: "uint32[]",
      },
      {
        internalType: "uint32[]",
        name: "maxQueuesPerUser",
        type: "uint32[]",
      },
      {
        internalType: "uint40[]",
        name: "recipeStartAts",
        type: "uint40[]",
      },
      {
        internalType: "uint40[]",
        name: "recipeExpirations",
        type: "uint40[]",
      },
    ],
    name: "addRecipesToBuilding",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "claimRecipe",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "recipeIds",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "indexes",
        type: "uint256[]",
      },
    ],
    name: "claimRecipes",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "landTokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "landBuildingId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
    ],
    name: "deleteLandBuildingRecipeRentConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "end",
        type: "uint256",
      },
    ],
    name: "getBuildingRecipes",
    outputs: [
      {
        internalType: "uint256[]",
        name: "recipeIds",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
    ],
    name: "getBuildingRecipesLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "landBuildingHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
    ],
    name: "getBuildingRentConfig",
    outputs: [
      {
        internalType: "bool",
        name: "isAvailable",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "rentFee",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getLand",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "landBuildingHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
    ],
    name: "getLandBuildingRecipeStatus",
    outputs: [
      {
        internalType: "uint256",
        name: "startAt",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "numberOfActiveRecipes",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getMap",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
    ],
    name: "getMaxQueueForRecipeInBuilding",
    outputs: [
      {
        internalType: "uint256",
        name: "maxQueue",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxQueuePerUser",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "recipeStartAt",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "recipeExpiration",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "landBuildingHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
    ],
    name: "getMaxQueueForUserInBuilding",
    outputs: [
      {
        internalType: "uint256",
        name: "maxQueueForUser",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getNextRecipeId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getNonce",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "getRecipe",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "token",
                type: "address",
              },
              {
                internalType: "enum ICraft.Action",
                name: "action",
                type: "uint8",
              },
              {
                internalType: "uint256",
                name: "tokenAmount",
                type: "uint256",
              },
            ],
            internalType: "struct ICraft.Consumes[]",
            name: "consumes",
            type: "tuple[]",
          },
          {
            components: [
              {
                internalType: "address",
                name: "token",
                type: "address",
              },
              {
                internalType: "bool",
                name: "isNFT",
                type: "bool",
              },
              {
                internalType: "uint128",
                name: "minTokenAmount",
                type: "uint128",
              },
              {
                internalType: "uint128",
                name: "maxTokenAmount",
                type: "uint128",
              },
              {
                internalType: "uint16[]",
                name: "metadataLimits",
                type: "uint16[]",
              },
            ],
            internalType: "struct ICraft.Produces[]",
            name: "produces",
            type: "tuple[]",
          },
          {
            internalType: "uint40",
            name: "duration",
            type: "uint40",
          },
          {
            internalType: "enum ICraft.RecipeQueueType",
            name: "queueType",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "recipeId",
            type: "uint256",
          },
        ],
        internalType: "struct ICraft.Recipe",
        name: "recipe",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "landBuildingHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
    ],
    name: "getUserActiveRecipeNumber",
    outputs: [
      {
        internalType: "uint256",
        name: "numberOfActiveRecipes",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "bytes32[]",
        name: "landBuildingHashes",
        type: "bytes32[]",
      },
    ],
    name: "getUserActiveRecipes",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "startAt",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "total",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "claimed",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "claimable",
            type: "uint256",
          },
          {
            internalType: "bytes32",
            name: "landBuildingHash",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "index",
            type: "uint256",
          },
        ],
        internalType: "struct ICraft.RecipeStatus[][]",
        name: "result",
        type: "tuple[][]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
    ],
    name: "getUserRecipeStatusLength",
    outputs: [
      {
        internalType: "uint256",
        name: "length",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "end",
        type: "uint256",
      },
    ],
    name: "getUserRecipeStatuses",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "startAt",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "total",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "claimed",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "claimable",
            type: "uint256",
          },
          {
            internalType: "bytes32",
            name: "landBuildingHash",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "index",
            type: "uint256",
          },
        ],
        internalType: "struct ICraft.RecipeStatus[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newOwner",
        type: "address",
      },
      {
        internalType: "address",
        name: "newTreasury",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
    ],
    name: "isConsumeTokenListed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "designer",
        type: "address",
      },
    ],
    name: "isDesigner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
    ],
    name: "isProduceTokenListed",
    outputs: [
      {
        internalType: "bool",
        name: "isListed",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isNFT",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "rand",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "producesToken",
        type: "address",
      },
    ],
    name: "removeProduceToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
    ],
    name: "removeRecipeFromBuilding",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newLand",
        type: "address",
      },
    ],
    name: "setLand",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newMap",
        type: "address",
      },
    ],
    name: "setMap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newTreasury",
        type: "address",
      },
    ],
    name: "setTreasury",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "consumesToken",
        type: "address",
      },
    ],
    name: "toggleConsumeToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "designerAddress",
        type: "address",
      },
    ],
    name: "toggleDesigner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "treasury",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "buildingNameHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "landTokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "landBuildingId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "rentFee",
        type: "uint256",
      },
    ],
    name: "updateLandBuildingRecipeRentConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "enum ICraft.Action",
            name: "action",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "tokenAmount",
            type: "uint256",
          },
        ],
        internalType: "struct ICraft.Consumes[]",
        name: "consumes",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "bool",
            name: "isNFT",
            type: "bool",
          },
          {
            internalType: "uint128",
            name: "minTokenAmount",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "maxTokenAmount",
            type: "uint128",
          },
          {
            internalType: "uint16[]",
            name: "metadataLimits",
            type: "uint16[]",
          },
        ],
        internalType: "struct ICraft.Produces[]",
        name: "produces",
        type: "tuple[]",
      },
    ],
    name: "updateRecipe",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "landBuildingHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "multiplier",
        type: "uint256",
      },
    ],
    name: "useRecipe",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "landBuildingHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "recipeId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "multiplier",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "useRecipe",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class Crafting__factory {
  static readonly abi = _abi;
  static createInterface(): CraftingInterface {
    return new Interface(_abi) as CraftingInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): Crafting {
    return new Contract(address, _abi, runner) as unknown as Crafting;
  }
}
